import { Col, Form, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import DatePicker from "react-datepicker";
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import Select from 'react-select';
import downloadImg from '../../assets/images/Dashboard/downloadImg.svg'
import { useRef, useState } from "react";

const UpdatedViewDetails = (props) => {
    const singleAssignedToSlaData = props?.singleAssignedToSlaData[0];
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    const renderTextWithTooltip = (text) => {
        // Check if the text length exceeds 24 characters
        if (text && text.length > 24) {
            return (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{text}</Tooltip>}
                >
                    <span style={{ textWrap: "nowrap" }}>{text.substring(0, 24)}...</span>
                </OverlayTrigger>
            );
        }
        return <span>{text}</span>;
    };

    const handledownloadFile = () => {
        const fileUrl = singleAssignedToSlaData?.FilePath;
        const fileName = singleAssignedToSlaData?.FileName;

        if (fileUrl) {
            // Create a temporary anchor element
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = fileName; // Suggest the file name to the user

            // Append the link to the body, click it, and remove it afterward
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return (
        <>
            <Modal show={props.open} onHide={props.handleClose} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Updated View Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>SLA Type</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.SLAType)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Company Name</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.CustomerName)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Checklist</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.SLACategoryName)}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Value Type</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.ValueType)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Baseline</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.BaseLine)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Targe%</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.TargetPercentage)}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Target Value</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.TargetValue)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Achieved Value</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.AchievedValue)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Achieved %</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.AchievedPercentage || "NA")}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} className="view-sla-data">
                                    <div className='add-customer-calendar-container'>
                                        <label>Start Date</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.StartDate)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4} className="view-sla-data">
                                    <div className='add-customer-calendar-container'>
                                        <label>End Date</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.EndDate)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Assigned To</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.AssignedTo)}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            {/* <Row> */}
                            {/* <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Actual Value</label>
                                        <span>$10,00,000</span>
                                    </div>
                                    <hr />
                                </Col> */}
                            {/* <Col md={4}>
                                    <div className='add-customer-calendar-container'>
                                        <label>Report Date</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.AssignedTo)}</span>
                                    </div>
                                    <hr />
                                </Col> */}
                            {/* <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Achieved %</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.AchievedPercentage || "NA")}</span>
                                    </div>
                                    <hr />
                                </Col> */}
                            {/* </Row> */}
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Department</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.DepartmentName || "NA")}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Assigned Score</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.AssignedScore)}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Status</label>
                                        <span>{renderTextWithTooltip(singleAssignedToSlaData?.Status)}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} className="d-flex justify-content-start align-items-center">
                                    <div className="dropdown add-single-bulk attachment-section">
                                        {/* <label>&nbsp;</label> */}
                                        <button
                                            className="download-document-btn"
                                            id="adduser-single-blulk"
                                        >
                                            <div className="ps-2">
                                                <span>File Name</span>
                                                <div className="attachment-note">
                                                    <small>(5MB)</small>
                                                </div>
                                            </div>
                                            <img src={downloadImg} alt="" className="download-img" />
                                        </button>
                                        {/* {selectedFile && <div className="attachment-note"><small>{selectedFile.name}</small></div>} */}
                                        <span style={{ fontSize: "0.8rem" }}>{renderTextWithTooltip(singleAssignedToSlaData?.FilePath)}</span>
                                    </div>
                                </Col>
                                <Col md={8}>
                                    <div className="view-sla-data">
                                        <label>Comments</label>
                                        <span className="description-text">{renderTextWithTooltip(singleAssignedToSlaData?.Remarks)}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleClose} />
                    <SBSaveUpdateBtn btnName="Ok" onClickEffect={props.handleNextStep} />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default UpdatedViewDetails;